<template>
  <section class="TcNewAppointment">
    <nav class="tabs mt-5">
      <span class="tab active">Solicitar cita</span>
      <span @click="$root.setPage('my-appointments')" class="tab">Ver mis citas</span>
    </nav>
    <ul class="w-1/2 mx-auto mt-12">
      <li class="bg-white hover:bg-gray-300 cursor-pointer py-9 flex items-center justify-start p-5 mb-5 shadow-md rounded-xl text-3xl"
        @click="$root.newAppointment(d)"
        v-for="d in getDelegations" v-bind:key="d.id">
        <svg class="h-8 w-8" :style="{color:d.color}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="12" fill="currentColor"/>
        </svg>
        <span class="ml-4">{{ d.name }}</span>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'TcNewAppointment',
  data () {
    return {
    }
  },
  computed: {
    getDelegations: function() {
      //console.log('ROOT USER', this.$root.user);
      if(this.$root.user) {
        if(this.$root.user.external) {
          return this.$root.delegations.filter(delegation => delegation.id == this.$root.member_external_room_id);
        } else {
          return this.$root.delegations;
        }
      } else {
        return [];
      }
    }
  },
  mounted() {
    //console.log('MOUNTED TcNewAppointment', this, this.$root.access_token);
    this.$root.loadDelegations().then(msg => {
      //console.log('delegations loaded', msg)
      // para cargar un calendario directamente
      //this.$root.newAppointment(1);
    });
  },
  created() {
    //console.log('CREATED TcNewAppointment', this);
  },
}
</script>